// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/transfer.css
// module id = 9g35
// module chunks = 4